import { supabase } from "./core.js";
import type { CRMEvent } from "../types/index.js";

export async function fetchCRMEvents(clientId: string): Promise<CRMEvent[]> {
  const { data, error } = await supabase
    .from("crm_events")
    .select("id, client_id, tipo_evento, descricao, data_evento, created_at")
    .eq("client_id", clientId)
    .order("data_evento", { ascending: false });
  if (error) throw error;
  return (data || []) as CRMEvent[];
}

export async function fetchAllCRMEvents(): Promise<Record<string, CRMEvent[]>> {
  const { data, error } = await supabase
    .from("crm_events")
    .select("id, client_id, tipo_evento, descricao, data_evento, created_at")
    .order("data_evento", { ascending: false });
  if (error) throw error;
  const grouped: Record<string, CRMEvent[]> = {};
  for (const ev of (data || []) as CRMEvent[]) {
    if (!grouped[ev.client_id]) grouped[ev.client_id] = [];
    grouped[ev.client_id].push(ev);
  }
  return grouped;
}

export async function insertCRMEvent(event: Partial<CRMEvent>): Promise<void> {
  const { error } = await supabase.from("crm_events").insert(event);
  if (error) throw error;
}

export async function deleteCRMEvent(eventId: string): Promise<void> {
  const { error } = await supabase.from("crm_events").delete().eq("id", eventId);
  if (error) throw error;
}
